/* Small repairs to content typed in the admin's rich text editor.

   Page and product bodies are store data, so the theme cannot edit them. These
   fix what would otherwise need a content edit on every page:

   - bare email addresses become mailto links
   - decorative underlines on non-links are cleared in CSS, not here

   Anything already inside a link is left alone. */
(function () {
  var EMAIL = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

  document.querySelectorAll('.prose-bb').forEach(function (root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.parentElement.closest('a, script, style')) return NodeFilter.FILTER_REJECT;
        return EMAIL.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    var targets = [];
    while (walker.nextNode()) targets.push(walker.currentNode);

    targets.forEach(function (node) {
      var frag = document.createDocumentFragment();
      var text = node.nodeValue;
      var last = 0;
      text.replace(EMAIL, function (match, offset) {
        if (offset > last) frag.appendChild(document.createTextNode(text.slice(last, offset)));
        var a = document.createElement('a');
        a.href = 'mailto:' + match;
        a.textContent = match;
        frag.appendChild(a);
        last = offset + match.length;
        return match;
      });
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  });
})();
